function initializeCartRecommendations() {
  const emblaNode = document.querySelector(".cart-recommendation .embla");
  
  if (!emblaNode) return;
  
  const prevBtnDesktop = document.querySelector(
    ".cart-recommendation .embla__controls--desktop .prev-btn"
  );
  const nextBtnDesktop = document.querySelector(
    ".cart-recommendation .embla__controls--desktop .next-btn"
  );
  
  const options = { 
    loop: false, 
    align: 'start',
    skipSnaps: false,
    containScroll: 'trimSnaps',
    dragFree: false,
    slidesToScroll: 1
  };
  
  const emblaApi = EmblaCarousel(emblaNode, options);

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    if (!prevBtn || !nextBtn) return;

    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) {
        prevBtn.removeAttribute("disabled");
      } else {
        prevBtn.setAttribute("disabled", "disabled");
      }

      if (emblaApi.canScrollNext()) {
        nextBtn.removeAttribute("disabled");
      } else {
        nextBtn.setAttribute("disabled", "disabled");
      }
    };

    prevBtn.addEventListener("click", () => emblaApi.scrollPrev(), false);
    nextBtn.addEventListener("click", () => emblaApi.scrollNext(), false);

    emblaApi
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState)
      .on("select", togglePrevNextBtnsState);

    return togglePrevNextBtnsState;
  };

  if (prevBtnDesktop && nextBtnDesktop) {
    addPrevNextBtnsClickHandlers(emblaApi, prevBtnDesktop, nextBtnDesktop);
  }
}

window.initializeCartRecommendations = initializeCartRecommendations;

document.addEventListener('DOMContentLoaded', initializeCartRecommendations);